import Swiper from "swiper/bundle";

class shopTheLook extends HTMLElement {
  constructor() {
    super();
    this.init();
  }

  init() {
    this.initHotspots();
  }

  initHotspots() {
    const swipers = this.querySelectorAll(".swiper");
    swipers.forEach((swiper) => {
      const swiperInstance = swiper.swiper;

      const hotspotsContainer = this.querySelector('[data-hotspots-container]');
      if (hotspotsContainer) {
        const buttons = hotspotsContainer.querySelectorAll('[data-slide-button]');

        // Make buttons more accessible
        buttons.forEach((button, index) => {
          button.setAttribute("aria-pressed", index === 0 ? "true" : "false");
        });

        if (buttons.length > 0) {
          buttons[0].classList.add("active");
        }

        const activateButton = (target) => {
          buttons.forEach((button) => {
            button.classList.remove("active");
            button.setAttribute("aria-pressed", "false");
          });
          target.classList.add("active");
          target.setAttribute("aria-pressed", "true");
          const slideIndex = parseInt(target.getAttribute("data-slide"), 10);
          swiperInstance.slideTo(slideIndex);

          // Scroll to anchor on mobile devices
          if (window.innerWidth <= 1023) {
            const anchor = document.querySelector("#shop-the-look-products");
            if (anchor) {
              anchor.scrollIntoView({ behavior: "smooth" });
            }
          }
        };

        hotspotsContainer.addEventListener("click", (event) => {
          if (event.target.matches('[data-slide-button]')) {
            activateButton(event.target);
          }
        });

        hotspotsContainer.addEventListener("keydown", (event) => {
          if (
            event.target.matches('[data-slide-button]') &&
            (event.key === "Enter" || event.key === " ")
          ) {
            event.preventDefault(); // Prevent page scroll on space
            activateButton(event.target);
          }
        });

        swiperInstance.on("slideChange", () => {
          const activeIndex = swiperInstance.activeIndex;
          buttons.forEach((button) => {
            button.classList.remove("active");
            button.setAttribute("aria-pressed", "false");
          });
          const activeButton = hotspotsContainer.querySelector(`[data-slide-button][data-slide="${activeIndex}"]`);
          if (activeButton) {
            activeButton.classList.add("active");
            activeButton.setAttribute("aria-pressed", "true");
          }
        });
      }
    });
  }
}

customElements.define("shop-the-look", shopTheLook);
